import { render, staticRenderFns } from "./Manter.vue?vue&type=template&id=66665eac&scoped=true"
import script from "./Manter.vue?vue&type=script&lang=ts"
export * from "./Manter.vue?vue&type=script&lang=ts"
import style0 from "./Manter.vue?vue&type=style&index=0&id=66665eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66665eac",
  null
  
)

export default component.exports